import React, { type FC } from 'react';
import { Button } from 'reactstrap';

interface Props {
    displayItem: number;
}


const Onboarding: FC<Props> = ({ displayItem}: Props) =>
{

  return  (
    <div>
        <h4>How to configure a web app to work perfectly with SGM Status</h4>
        <br/>
        {displayItem == 0 ?
        <>
            <h5 id="configure-credential">Configure your web app cfredential</h5>
            <p className='mb-4 mt-4'>If your Api already declare its credentials, you should have something like that:<br/>
                <img src="/doc_api_credentials.png" alt="api credentials" title="api credentials" style={{ border: "1px #ccc solid", width:"90%"}} className='mt-2 ms-4' />
            </p>
            <p className='mb-4'>If not, you should have something like this:<br/>
                <img src="/doc_missing_credentials.png" alt="missing credentials" title="missing credentials" style={{ border: "1px #ccc solid", width:"90%"}} className='mt-2 ms-4' />
            </p>
            <p className='mb-4'>Then you should click on import your credentials:<br/>
                <img src="/doc_missing_credentials_import.png" alt="missing credentials import" title="missing credentials import" style={{ border: "1px #ccc solid"}} className='mt-2 ms-4' />
            </p>
            <p className='mb-4'>And then, choose the right credential to import:<br/>
                <img src="/doc_missing_credentials_import_choose.png" alt="missing credentials choose" title="missing credentials choose" style={{ border: "1px #ccc solid"}} className='mt-2 ms-4' />
            </p>
        </>
        : null
        }
        {displayItem == 1 ?
        <>
            <h5 id="configure-webapp">Configure your web app</h5>
            <p className='mb-4 mt-4'>If your WebApp is not yet configure, the gear should appear in <span style={{ color: 'red' }}><b>red</b></span><br/>
                <img src="/doc_configure_webapp_1.png" alt="configure webApp" style={{ border: "1px #ccc solid", width:"90%"}} className='mt-2 ms-4' />
                <br/>
                <br/>
                If so, click on the red gear.
            </p>
            
            <p className='mb-4 mt-4'>A new window shoudl appear to help you confiure your web app<br/>
                <img src="/doc_configure_webapp_2.png" alt="configure webApp" style={{ border: "1px #ccc solid"}} className='mt-2 ms-4' />
                <br/>
                <br/>
                In the first section, you should insert your producer code. (the one you are using for partial incident)<br />
                In the second section called "Api Environments", you should see the list of all environments describe in developer portal.
                <img src="/doc_configure_webapp_3.png" alt="configure webApp" style={{ border: "1px #ccc solid", width:"90%"}} className='mt-2 ms-4' />
                If your credential are correctly filled, you should see the list of your referenced Apis. If you need to add more api, you can use the "+ Add" button: 
                <img src="/doc_configure_webapp_4.png" alt="configure webApp" style={{ border: "1px #ccc solid"}} className='mt-2 ms-4' />
                Once all your Apis are listed, click on "Save".<br/>
                Then you can click on "Compute" to start to process your web app or wait until the batch process it (the batch is triggered every 8 hours).

            </p>
        </>
        : null
        }
        {displayItem == 2 ?
        <>
            <h5 id="configure-webapp">Configure your Api Healthcheck</h5>
            <p className='mb-4 mt-4'>All the logic of SGM Status is in the ApiHealthCheck.<br/>

            <ul>
            <li>For dotnet, you can follow this <a href="https://sgithub.fr.world.socgen/sgm-api/sg-markets-aspnetcore/blob/main/docs/HealthChecks.md" target='_blank'>documentation</a><br/></li>
            <li>For java, you can follow this <a href="https://sgithub.fr.world.socgen/sgm-api/sg-markets-java-api-libraries/tree/main/sgm-api-libraries-healthcheck" target='_blank'>documentation</a><br/></li>
            </ul>
            <br/>
            <h6>Example of the result of an healthcheck</h6>
            <img src="/doc_configure_webapp_5.png" alt="configure webApp" style={{ border: "1px #ccc solid"}} className='mt-2 ms-4' />
            <br/>
            <br/>
            <b>It is very important to correctly declare all the Apis you are using with the following informations:
            <ul>
                <li>apiCode</li>
                <li>apiVersion</li>
                <li>apiEnvironment</li>
                <li>healthUrl</li>
            </ul><br/>
            </b>
            These information will be used in the batch to build your Api Graph.<br/>
            <br/>
            Also, you are not limited to the apis health, you can also create check for anything like:
            <ul>
                <li>You database</li>
                <li>Your batch result</li>
                <li>The number of error to not reached by minutes/hours</li>
                <li>Check on your system (CPU/RAM)</li>
                <li>Check on any middleware</li>
                <li>etc.</li>
            </ul>
            <br/> 
            <i>The more accurate your healthcheck are, the more accurate result you will get.</i>
            <br/> 
            </p>
        </>
        : null
        }
        
    </div> 
  );
}
export default Onboarding;
